import type { GiphyItem } from "@circle-react-uikit/TipTapBlockEditor/GiphyPickerModal";
import { Icon } from "@circle-react/components/shared/Icon";
import InfiniteScroll from "react-infinite-scroll-component";
import Masonry from "react-responsive-masonry";

import { EmptyState } from "./EmptyState";
import { GifItem } from "./GifItem";
import { GiphyGridSkeleton } from "./GiphyGridSkeleton";
import { LegacyLoader } from "./LegacyLoader";

interface PickerBodyProps {
  close: () => void;
  fetchNextPage: () => void;
  gifs: GiphyItem[];
  hasNextPage: boolean;
  isCompassEnabled: boolean;
  isInitialLoading: boolean;
}

export const PickerBody = ({
  gifs,
  isInitialLoading,
  isCompassEnabled,
  hasNextPage,
  fetchNextPage,
  close,
}: PickerBodyProps) => {
  if (isInitialLoading) {
    return isCompassEnabled ? <GiphyGridSkeleton /> : <LegacyLoader />;
  }

  if (!gifs.length) {
    return <EmptyState />;
  }

  return (
    <InfiniteScroll
      dataLength={gifs.length}
      next={fetchNextPage}
      hasMore={hasNextPage}
      scrollThreshold={0.6}
      height={360}
      loader={
        isCompassEnabled ? (
          <div className="py-2">
            <GiphyGridSkeleton count={3} />
          </div>
        ) : (
          <div className="col-span-2 flex justify-center py-3">
            <Icon type="loader" />
          </div>
        )
      }
      className={isCompassEnabled ? undefined : "mb-2 p-2"}
    >
      <Masonry columnsCount={isCompassEnabled ? 3 : 2} gutter="8px">
        {gifs.map(gif => (
          <GifItem key={gif.id} gif={gif} close={close} />
        ))}
      </Masonry>
    </InfiniteScroll>
  );
};
